// Temporary, effective copy of https://github.com/get-bridge/bridge-platform-runtime/blob/6dde266893e145d012d13b66d9ff40fd5e8d12fd/bridge-nav/src/notifications/schemas/NotificationSchema.ts
import SchemaPropTypes from '@get-bridge/learn-legacy-shared/dist/shared/SchemaPropTypes';
const { array, bool, object, oneOfType, string, shape } = SchemaPropTypes;

export default shape({
  id: string, //.isRequired
  userId: string, //.isRequired
  // NC model - string, perform html model - array
  body: oneOfType([array, string]),
  sentAt: string, //.isRequired
  read: bool, //.isRequired

  // perform html model
  subject: string, //.isRequired

  // NC model
  title: string,
  priority: string, //.isRequired
  icon: object, // todo
  links: array, // todo
});



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/notifications/schemas/NotificationSchema.js